"use client";

import Link from "next/link";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <main id="main-content" className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">
          {t("notFound.message")}
        </p>
        <Link href="/" className="text-primary underline hover:text-primary/90">
          {t("notFound.backHome")}
        </Link>
      </main>
    </div>
  );
}
